<template>
  <v-hover>
    <template v-slot:default="{ isHovering, props }">
      <v-sheet v-if="report" v-bind="props" class="d-flex justify-space-between border-b-md pa-2" :class="{'border-t-sm': index === 0}" >
        <v-sheet width="100%" style="cursor: pointer;" block variant="plain" rounded="0">
          <v-sheet class="d-flex justify-space-between align-top">
            <v-sheet>
              <p class="text-left pr-1 font-weight-bold">{{ report.name }}</p>
              <p style="font-size: 12px; opacity: 0.3;" class="text-left">{{ report.description }}</p>
            </v-sheet>
          </v-sheet>


          <v-sheet color="transparent" class="d-flex justify-space-between align-center">
            {{ moment(report.range.start).format("DD.MM.YYYY") }}
            <v-divider class="mx-1" />
            <p style="font-size: 10px; opacity: 0.5">ПЕРИОД</p>
            <v-divider class="mx-1" />
            {{ moment(report.range.end).format("DD.MM.YYYY") }}
          </v-sheet>
          <v-sheet color="transparent" class="d-flex justify-space-between align-center" style="opacity: 0.5;">
            <span class="font-weight-bold">ЗАКАЗЧИК</span>
            {{ JSON.parse(report.line)['Заказчик'] }}
          </v-sheet>
          <v-sheet color="transparent" class="d-flex justify-space-between align-center" style="opacity: 0.5;">
            <span class="font-weight-bold">ОБЪЕКТ</span>
            {{ JSON.parse(report.line)['Объект'] }}
          </v-sheet>
        </v-sheet>
        <v-scroll-x-reverse-transition>
          <v-sheet v-if="isHovering" color="transparent" class="d-flex flex-column justify-space-between ml-2">
            <v-sheet width="100%">
              <v-btn block flat color="green" :icon="true" v-on:click="selectLocalFile()">
                <v-icon :icon="['fas', 'square-arrow-up-right']" />
              </v-btn>
            </v-sheet>

            <v-sheet width="100%">
              <v-btn block flat color="red" variant="text" :icon="true" v-on:click="delete_report()">
                <v-icon :icon="['fas', 'trash']" />
              </v-btn>
            </v-sheet>

          </v-sheet>
        </v-scroll-x-reverse-transition>
      </v-sheet>
    </template>
  </v-hover>

</template>

<script>
import { Allerts } from "@/store/global/Allerts";
import {Rep_Contract, Rep_Contracts, Rep_Loading, Rep_Period} from "@/store/report/SmallStorrage";
import { ReportData } from "@/store/report/ReportData";
import {ItemData, ItemDesc, ItemName, ItemUUID, ListOfReports} from "@/store/report/save.store";
import moment from "moment";
import {TokenGUIDStore} from "@/store/global/SessionStore";

export default {
  name: "BrowserSaver__Card",
  props: ['report', 'index'],
  methods: {
    selectLocalFile: function () {
      this.item_data = this.report
      this.item_name = this.report.name
      this.item_desc = this.report.description
      this.item_uuid = this.report.uuid

      this.report_data = JSON.parse(this.report.line)
      this.range = this.report.range
      this.contract = this.report.contract
      this.$router.push({ name: 'report__editor'})
      Allerts().warn('ЗАГРУЖЕНО', `Файл успешно подгружен!`,'light-green', 'floppy-disk')
    },
    delete_report: async function () {
      this.is_loading = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/rm/delete`

      let properies = {
        method: 'POST',
        body: JSON.stringify({
          guid: this.report.uuid
        }),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения Документов!`
            }
          })
          .then(result => {
            console.log(result)
            this.list = result
          }).catch(err => {
            Allerts().warn('ОШИБКА', err, '#ff0000', 'triangle-exclamation')
            console.error(err)
          }).finally(() => {
            this.is_loading = false
          })
    }
  },
  computed: {

    moment() {
      return moment
    },
    contracts: {
      get() {
        return Rep_Contracts().get()
      },
      set(value) {
        Rep_Contracts().set(value)
      }
    },
    is_loading: {
      get() {
        return Rep_Loading().get()
      },
      set(value) {
        Rep_Loading().set(value)
      }
    },
    range: {
      get() {
        return Rep_Period().get()
      },
      set(value) {
        Rep_Period().set(value)
      }
    },
    contract: {
      get() {
        return Rep_Contract().get()
      },
      set(value) {
        Rep_Contract().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    },
    item_uuid: {
      get() {
        return ItemUUID().get()
      },
      set(value) {
        ItemUUID().set(value)
      }
    },
    item_name: {
      get() {
        return ItemName().get()
      },
      set(value) {
        ItemName().set(value)
      }
    },
    item_desc: {
      get() {
        return ItemDesc().get()
      },
      set(value) {
        ItemDesc().set(value)
      }
    },
    item_data: {
      get() {
        return ItemData().get()
      },
      set(value) {
        ItemData().set(value)
      }
    },
    list: {
      get() {
        return ListOfReports().get()
      },
      set(value) {
        ListOfReports().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}
</script>

<style scoped>

</style>
